<template>
    <div class="mb-5">
        <h5>{{ $t('Basic Information') }}</h5>
        <hr>
        <div class="px-3 mb-3 mt-3">
            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Business Name') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <input type="text" class="form-control" v-model="params.name" @keydown="onChange('name')"/>
                    <div v-if="error['name']" class="invalid-feedback d-block mb-3">
                        {{$t(error['name'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Business English Name') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <input type="text" class="form-control" v-model="params.enName" @keydown="onChange('enName')"/>
                    <div v-if="error['enName']" class="invalid-feedback d-block mb-3">
                        {{$t(error['enName'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col xl="4" sm="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('Province') }} <span class="text-danger">*</span></label>
                        <Select2 v-model="params.province" :options="provinceOpt" @select="onSelectProvince($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Province")}' class="form-control"/>
                        <div v-if="error['province']" class="invalid-feedback d-block mb-3">
                            {{$t(error['province'])}}
                        </div>
                    </div>
                </b-col>
                <b-col xl="4" sm="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('City') }} <span class="text-danger">*</span></label>
                        <Select2 v-model="params.city" :options="cityOpt" @select="onSelectCity($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("City")}' class="form-control"/>
                        <div v-if="error['city']" class="invalid-feedback d-block mb-3">
                            {{$t(error['city'])}}
                        </div>
                    </div>
                </b-col>
                <b-col xl="4" sm="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('District') }}</label>
                        <Select2 v-model="params.area" :options="districtOpt" @select="onSelectDistrict($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("District")}' class="form-control"/>
                        <div v-if="error['area']" class="invalid-feedback d-block mb-3">
                            {{$t(error['area'])}}
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col xl="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('Address') }} <span class="text-danger">*</span></label>
                        <input type="text" name="address" v-model="params.address" class="form-control" @keydown="addressCondition($event)" @keyup="onchangeAddress($event)"/>
                        <div v-if="error['address']" class="invalid-feedback d-block mb-3">
                            {{$t(error['address'])}}
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Certificate of Registration Number') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <input type="text" class="form-control" v-model="params.orgRegisterNo" @keydown="onChange('orgRegisterNo')"/>
                    <div v-if="error['orgRegisterNo']" class="invalid-feedback d-block mb-3">
                        {{$t(error['orgRegisterNo'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col cols="12" md="3">
                    <label>{{ $t('Certificate of Registration') }} <span class="text-danger">*</span></label>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup('showPopup_4')">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="'certificate_registration'" v-if="showPopup_4"></NewPopupInfo>
                    </span>
                </b-col>

                <b-col cols="12" md="9">
                    <FileUploader  
                        :type="'browse'"
                        :ref="'orgRegister'"
                        :default_image="params.orgRegister"
                        :allowed_types = "['jpg','jpeg', 'png','pdf']"
                        :size="10*1024*1024"
                        @capture-file="captureFile($event,'orgRegister')" 
                        @remove-image="removeImage($event,'orgRegister')">
                    </FileUploader>
                    <div v-if="error['orgRegister']" class="invalid-feedback d-block mb-3">
                        {{$t(error['orgRegister'])}}
                    </div>
                </b-col>
            </b-row>


            <b-row class="mb-4">
                <b-col cols="12" md="3">
                    <label>{{ $t('Annual Return') }} <span class="text-danger">*</span></label>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup('showPopup_2')">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="'annual_return'" v-if="showPopup_2"></NewPopupInfo>
                    </span>
                </b-col>

                <b-col cols="12" md="9">
                    <FileUploader  
                        :type="'browse'"
                        :ref="'declarationForm'"
                        :allowed_types = "['jpg','jpeg', 'png','pdf','rar','zip']"
                        :size="20*1024*1024"
                        :default_image="params.declarationForm"
                        @capture-file="captureFile($event,'declarationForm')" 
                        @remove-image="removeImage($event,'declarationForm')">
                    </FileUploader>
                    <div v-if="error['declarationForm']" class="invalid-feedback d-block mb-3">
                        {{$t(error['declarationForm'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col cols="12" md="3">
                    <label>{{ $t('Incorporation Form') }} <span class="text-danger">*</span></label>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup('showPopup_6')">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="'form_incorporation'" v-if="showPopup_6"></NewPopupInfo>
                    </span>
                </b-col>

                <b-col cols="12" md="9">
                    <FileUploader  
                        :type="'browse'"
                        :ref="'incorporationForm'"
                        :allowed_types = "['jpg','jpeg', 'png','pdf','rar','zip']"
                        :size="20*1024*1024"
                        @capture-file="captureFile($event,'incorporationForm')" 
                        @remove-image="removeImage($event)">
                    </FileUploader>
                    <div v-if="error['incorporationForm']" class="invalid-feedback d-block mb-3">
                        {{$t(error['incorporationForm'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col cols="12" md="3">
                    <label>{{ $t('Business Registration Certificate') }} <span class="text-danger">*</span></label>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup('showPopup')">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="'business_certificate'" v-if="showPopup"></NewPopupInfo>
                    </span>
                </b-col>

                <b-col cols="12" md="9">
                    <FileUploader  
                        :type="'browse'"
                        :ref="'businessRegister'"
                        :allowed_types = "['jpg','jpeg', 'png','pdf']"
                        :size="10*1024*1024"
                        :default_image="params.businessRegister"
                        @capture-file="captureFile($event,'businessRegister')" 
                        @remove-image="removeImage($event,'businessRegister')">
                    </FileUploader>
                    <div v-if="error['businessRegister']" class="invalid-feedback d-block mb-3">
                        {{$t(error['businessRegister'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Validity Period of The Business Registration Certificate') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <date-picker v-model="params.businessRegisterExpiryDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('businessRegisterExpiryDate')"></date-picker>
                    <div v-if="error['businessRegisterExpiryDate']" class="invalid-feedback d-block mb-3">
                        {{$t(error['businessRegisterExpiryDate'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Business Registration Number') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <input type="text" class="form-control" v-model="params.businessRegisterNo" @keydown="onChange('businessRegisterNo')"/>
                    <div v-if="error['businessRegisterNo']" class="invalid-feedback d-block mb-3">
                        {{$t(error['businessRegisterNo'])}}
                    </div>
                </b-col>
            </b-row>

           
            <b-row class="mb-4">
                <b-col cols="12" md="3">
                    <label>{{ $t('Shareholding Structure') }} <span class="text-danger">*</span></label>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup('showPopup_5')">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="'equity_structure'" v-if="showPopup_5"></NewPopupInfo>
                    </span>
                </b-col>

                <b-col cols="12" md="9">
                    <FileUploader  
                        :type="'browse'"
                        :ref="'stockCertificate'"
                        :default_image="params.stockCertificate"
                        :allowed_types = "['jpg','jpeg','png','pdf','docx','rar','zip']"
                        :size="20*1024*1024"
                        @capture-file="captureFile($event,'stockCertificate')" 
                        @remove-image="removeImage($event,'stockCertificate')">
                    </FileUploader>
                    <div v-if="error['stockCertificate']" class="invalid-feedback d-block mb-3">
                        {{$t(error['stockCertificate'])}}
                    </div>
                    <a :href="`${publicPath}img/gep/business/hongkong/Equity structure template.docx`" class="d-block fz-12 text-blue mt-2 text-right">Download shareholding structure template</a>
                </b-col>
            </b-row>

        </div>
    </div>
</template>

<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2 from 'v-select2-component';

import NewDocOption from "@/components/Kyc/NewDocOption";
import FileUploader from '@/components/Kyc/FileUploader.vue';
import NewPopupInfo from '@/components/NewPopupInfo.vue';
import CreateAccount from '@/services/CreateAccount';

import 'vue2-datepicker/locale/zh-cn';
import 'vue2-datepicker/locale/zh-tw';
import 'vue2-datepicker/locale/ja';
import 'vue2-datepicker/locale/en';

export default {
  data() {
    return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        cityOpt:[],
        districtOpt:[],
        city:'',
        province:'',
        area:'',
        address:'',
        maxSize:4,
        showPopup:false,
        showPopup_2:false,
        showPopup_3:false,
        showPopup_4:false,
        showPopup_5:false,
        showPopup_6:false,
        lang_date:'en',
        success:null,
        optional:['area'],
        formData:{},
        file:{
            orgRegister:null,
            declarationForm:null,
            incorporationForm:null,
            businessRegister:null,
            stockCertificate:null
        },
        params:{
            name:'',
            enName:'',
            province:'',
            city:'',
            area:'',
            address:'',
            orgRegister:'',
            orgRegisterNo:'',
            declarationForm:'',
            incorporationForm:'',
            businessRegister:'',
            businessRegisterExpiryDate:'',
            businessRegisterNo:'',
            stockCertificate:''
        },
        error:{
            name:'',
            enName:'',
            province:'',
            city:'',
            area:'',
            address:'',
            orgRegister:'',
            orgRegisterNo:'',
            declarationForm:'',
            incorporationForm:'',
            businessRegister:'',
            businessRegisterExpiryDate:'',
            businessRegisterNo:'',
            stockCertificate:''
        }
    }
  },
  components:{
    NewDocOption,
    FileUploader,
    Select2,
    NewPopupInfo,
    DatePicker
  },
  props:['provinceOpt','userNo','accountId'],
  mounted(){
    let self = this;
    CreateAccount.list({
        search:self.search,
        start:0,
        length:-1
    }).then((response)=>{
        if (response.status == 200) {
            self.formData = response.data.data[0]['information'];

            Object.keys(this.params).forEach(function(key) {

                if(typeof self.file[key]!=="undefined" && self.formData[key]){
                    self.file[key]=self.formData[key];
                    self.getFile(key,self.formData[key]);
                }
                else{
                    self.params[key]=self.formData[key];
                }
            });

            let data_province = this.params.province.split("_");
            this.getCity(data_province[0]);

            let data_city = this.params.city.split("_");
            this.getDistrict(data_city[0]);
        }
    });
  },
  methods:{
    onSelectProvince({id,text,code}){
        var self = this;
        this.onChange('province');
        self.districtOpt = [];
        if(text){
            this.city = "";
            this.area="";
        }
        this.getCity(code);
    },
    getCity(code){
        this.cityOpt = [];
        CreateAccount.getCity({"province_id":code}).then(response => {
            const data = response.data.data;
            data.forEach(item => {
                this.cityOpt.push({"id":item.value,"text":item.text,"code":item.code});
            });
        }).catch(err => {
            this.checkError(err);
        });
    },
    getDistrict(code){
        this.districtOpt = [];
        CreateAccount.getDistrict({"city_id":code}).then(response => {
            const data = response.data.data;
            data.forEach(item => {
                this.districtOpt.push({"id":item.value,"text":item.text,"code":item.code});
            });
        }).catch(err => {
            this.checkError(err);
        });
    },
    getFile(index,file_id){
        let self = this;
        CreateAccount.getFile({fileId:file_id}).then(response => {
            let data_file = response.data.data[0];
            if(data_file.type == 8){
                self.params.orgRegister = data_file.file;
            }
            else if(data_file.type == 9){
                self.params.declarationForm = data_file.file;
            }
            else if(data_file.type == 27){
                self.params.incorporationForm = data_file.file;
            }
            else if(data_file.type == 10){
                self.params.businessRegister = data_file.file;
            }
            else if(data_file.type == 11){
                self.params.stockCertificate = data_file.file;
            }
        });
    },
    validate(){
        let success = true;
        let self = this;
        Object.keys(this.params).forEach(function(key) {
            if(!self.params[key]){
                console.log(key+" can not be blank.");
                self.error[key]="can not be blank.";
                success = false;
            }
        });

        return success;
    },
    uploadFile(){
        let self = this;
        this.success = null;
        
        this.error.orgRegister='';
        this.error.incorporationForm = '';
        this.error.declarationForm='';
        this.error.businessRegister='';
        this.error.stockCertificate='';

        let file = [];
        if(self.params.orgRegister.indexOf("base64")!=-1){
            file.push({
                "type":8,
                "maxSize":10*1024*1024,
                "file":self.params.orgRegister
            });
        }
        if(self.params.declarationForm.indexOf("base64")!=-1){
            file.push({
                    "type":9,
                    "maxSize":20*1024*1024,
                    "file":self.params.declarationForm
                });
        }
        if(self.params.incorporationForm.indexOf("base64")!=-1){
            file.push({
                    "type":27,
                    "maxSize":20*1024*1024,
                    "file":self.params.incorporationForm
                });
        }
        if(self.params.businessRegister.indexOf("base64")!=-1){
            file.push({
                    "type":10,
                    "maxSize":10*1024*1024,
                    "file":self.params.businessRegister
                });
        }
        if(self.params.stockCertificate.indexOf("base64")!=-1){
            file.push({
                    "type":11,
                    "maxSize":20*1024*1024,
                    "file":self.params.stockCertificate
                });
        }
        

        if(file.length>0){
            CreateAccount.uploadFile({
                "accountId":self.accountId,
                "userNo":""+self.userNo,
                "fileUpload":file
            }).then(response => {
                const data = response.data.data;
                let fileList = data["file"];
                for(let i=0;i<fileList.length;i++){
                    if(fileList[i].type==8){
                        // self.params.orgRegister = fileList[i].file;
                        self.file.orgRegister = fileList[i].fileId;
                    }
                    else if(fileList[i].type==9){
                        // self.params.declarationForm = fileList[i].file;
                        self.file.declarationForm = fileList[i].fileId;
                    }
                    else if(fileList[i].type==27){
                        // self.params.declarationForm = fileList[i].file;
                        self.file.incorporationForm = fileList[i].fileId;
                    }
                    else if(fileList[i].type==10){
                        // self.params.businessRegister = fileList[i].file;
                        self.file.businessRegister = fileList[i].fileId;
                    }
                    else if(fileList[i].type==11){
                        // self.params.stockCertificate = fileList[i].file;
                        self.file.stockCertificate = fileList[i].fileId;
                    }
                }
                self.success = true;
                self.$emit('file-uploaded');
            }).catch(err => {
                console.log("===== err ======");
                console.log(err);
                self.checkError(err);
            });
        }
        else{
            self.success = true;
            self.$emit('file-uploaded');
        }
    },
    onChange(name){
        this.error[name]="";
    },
    checkError(err){
        try{
            let self = this;
            const response = err.response;  
            console.log("====res=====");
            console.log(response);
            if(response.status == 400){
                if(typeof response.data.message === 'string'){
                    this.$notify({
                        type: 'warn',
                        text: response.data.message
                    });
                }
                else{
                    if(response.data.message['file']){
                        let fileList = response.data.message['file'];
                        for(let i=0;i<fileList.length;i++){
                            if(fileList[i].type==8){
                                this.error.orgRegister=fileList[i].message;
                            }
                            else if(fileList[i].type==9){
                                this.error.declarationForm=fileList[i].message;
                            }
                            else if(fileList[i].type==27){
                                this.error.incorporationForm=fileList[i].message;
                            }
                            else if(fileList[i].type==10){
                                this.error.businessRegister=fileList[i].message;
                            }
                            else if(fileList[i].type==11){
                                this.error.stockCertificate=fileList[i].message;
                            }
                        }
                    }
                    self.success = false;
                    self.$emit('file-uploaded');
                }
            }      
            else if(response.status == 401 && response.data.name == "Unauthorized"){
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({ 
                        path: '/login', 
                    });
            }
            else{
                if(localStorage.getItem("token")){
                    var msg = (response.data)?response.data.message:err.message;
                    this.$notify({
                        type: 'warn',
                        text: msg
                    })
                }
            }
        }catch(e){
            console.log(err);
        }
    },
    togglePopup(item){
        this[item]=!this[item];
    },
    captureFile($event,key) {
        this.error[key]="";
        this.file[key]="";
        this.params[key]=$event;
    },
    removeImage($event,key){
        this.file[key]="";
        this.params[key]="";
        console.log($event);
    },
    doEscapeMarkup(markup){
        return markup;
    }
  }
}
</script>